// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:43.497Z
// Property: Barrington Apartments (ID: 6767906449165586)
// Collections: 21 amenities, 10 floorplans (live), 45 photos, 70 POIs, 1 reviews, 1 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165586",
  "property_external_id": "qpr7jhy",
  "property_zillow_url": "https://www.zillow.com/apartments/tulsa-ok/barrington-apartments/5XhzSq/",
  "property_apartments_url": "https://www.apartments.com/barrington-apartments-tulsa-ok/qpr7jhy/",
  "property_google_business_url": "https://www.google.com/maps/place/Barrington+Apartments/data=!4m2!3m1!1s0x0:0x7f2fc04c8b8451f4?sa=X&ved=2ahUKEwjj5JWh8rySAxUiSTABHf8rCjEQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8442922139",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "barrington-apartments",
  "property_name": "Barrington Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/barrington/",
  "property_domain": null,
  "property_address": "9233 E. 65th St.",
  "property_full_address": "9233 E. 65th St., Tulsa, OK, 74133",
  "property_address_1": "9233 E. 65th St.",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0704",
  "property_address_longitude": "-95.8727",
  "property_email": "barrington@caseusa.com",
  "property_phone": "(539) 207-4532",
  "property_call_tracking_phone": "800-624-7043",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Barrington Apartments in Tulsa, find your perfect home among our spacious one, two, and three-bedroom floor plans. Enjoy top-notch amenities like a refreshing pool, fitness center, and a vibrant clubhouse. With smoke-free living and high-speed internet, your ideal lifestyle awaits. Browse our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Barrington Apartments in Tulsa, Oklahoma**\n\nDiscover your perfect home at Barrington Apartments, where comfort meets convenience in the heart of Tulsa. Our vibrant community offers an impressive selection of spacious floor plans, including one, two, and three-bedroom apartments designed to fit your lifestyle. Each residence features modern amenities such as a washer/dryer, dishwasher, refrigerator, and high-speed internet access, ensuring that you have everything you need right at your fingertips.\n\nAt Barrington Apartments, we believe in providing a well-rounded living experience. That’s why we offer a host of fantastic amenities for all residents to enjoy. Relax by our resort-style pool or stay active in our fully-equipped fitness center. The on-site playground offers a fun space for children, while sports enthusiasts can take advantage of our basketball and volleyball courts. Our inviting clubhouse is the perfect setting for social gatherings or meetings, and our business center provides the ideal workspace for remote work.\n\nWith conveniences like package service, onsite maintenance, and a dedicated property manager, we prioritize your comfort and peace of mind. Enjoy fresh air and scenic views from your private balcony or patio, complete with vaulted ceilings that make your space feel even larger. \n\nExperience the vibrant lifestyle you deserve at Barrington Apartments. Find your new home today — browse our availability or schedule a tour to visit our community! Your ideal living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019fb44b-2eea-755a-8708-09e27800bad5.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a townhouse style apartment building with stone and white siding.",
    "public_id": "019fb44b-2eea-755a-8708-09e27800bad5",
    "storage_key": "property/6767906449165586/019fb44b-2eea-755a-8708-09e27800bad5.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "212",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "0",
  "property_max_pet_weight_limit": "40",
  "property_pet_restrictions": "Maximum of 2 pets per unit. Maximum weight: 40 lb each.",
  "property_pet_policy_description": "Cats and dogs allowed. One-time pet fee: $500 per pet. Monthly pet rent: $25 per pet. Maximum of 2 pets per unit. Maximum weight: 40 lb each.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://barringtonapartmentstulsa.securecafe.com/onlineleasing/barrington-apartments-0/floorplans.aspx",
  "property_resident_portal_url": "https://barringtonapartmentstulsa.securecafe.com/residentservices/barrington-apartments-0/userlogin.aspx",
  "property_apply_now_url": "https://barringtonapartmentstulsa.securecafe.com/onlineleasing/barrington-apartments-0/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-2914-7206-ac11-405b0dad83bb.webp",
  "property_primary_logo_media": {
    "alt_text": "Barrington Apartments logo",
    "public_id": "019cfb39-2914-7206-ac11-405b0dad83bb",
    "storage_key": "property/6767906449165586/019cfb39-2914-7206-ac11-405b0dad83bb.webp",
    "width": 668,
    "height": 329
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb3a-1b92-761e-ba11-c25c3cfd1f7f.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3a-1b92-761e-ba11-c25c3cfd1f7f",
    "storage_key": "property/6767906449165586/019cfb3a-1b92-761e-ba11-c25c3cfd1f7f.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb3a-4357-7036-903c-a1174b133269.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Barrington Apartments logo",
    "public_id": "019cfb3a-4357-7036-903c-a1174b133269",
    "storage_key": "property/6767906449165586/019cfb3a-4357-7036-903c-a1174b133269.webp",
    "width": 640,
    "height": 315
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb3a-5727-7093-8c4c-fe78d095f34e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Barrington Apartments logo.",
    "public_id": "019cfb3a-5727-7093-8c4c-fe78d095f34e",
    "storage_key": "property/6767906449165586/019cfb3a-5727-7093-8c4c-fe78d095f34e.webp",
    "width": 640,
    "height": 315
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#b47f00",
  "property_secondary_color": "#5e5e5e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "600 - 1360",
  "property_sqft_min": "600",
  "property_sqft_max": "1360",
  "property_price_range": "929 - 1639",
  "property_price_min": "929",
  "property_price_max": "1639",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/BarringtonTulsa/photos/",
  "property_instagram_url": "https://www.instagram.com/barringtonapartmentstulsa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_SSn6aONtocR9FGEi0zAL38",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/barrington-apartments-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@barrapt1983",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Barrington Apartments",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "At Barrington Apartments in Tulsa, Oklahoma, choose from spacious one, two, or three-bedroom layouts tailored for your lifestyle. Enjoy invigorating amenities like a shimmering pool, fitness center, and sports courts, alongside modern comforts such as high-speed internet and in-unit washers. Elevate your living experience in our vibrant community!",
  "property_home_floorplans_blurb": "Welcome to Barrington Apartments in Tulsa, Oklahoma, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom floor plans tailored to suit your lifestyle. Each home offers unique features and modern amenities. Browse our available options and find the perfect space to call your own today!",
  "property_home_gallery_blurb": "At Barrington Apartments in Tulsa, Oklahoma, find your perfect home with spacious one, two, and three-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a sparkling pool, fitness center, and playground. Picture yourself unwinding on your private balcony or enjoying a game on our courts—your dream apartment awaits!",
  "property_home_neighborhood_blurb": "At Barrington Apartments in Tulsa, enjoy a lifestyle that balances modern living with a vibrant neighborhood. Engage with local attractions like the Oklahoma Aquarium, Urban Air Trampoline Park, and nearby beautiful parks. With spacious one, two, and three-bedroom floor plans, your perfect home awaits amid dynamic amenities and recreation.",
  "property_home_reviews_blurb": "At Barrington Apartments in Tulsa, we pride ourselves on creating a welcoming community where comfort and safety come first. As one resident noted, “Our maintenance men are efficiently handling our work orders,” ensuring your home remains a place of peace. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in vibrant Tulsa, Barrington Apartments offers more than just a home. With local treasures like the Oklahoma Aquarium and Urban Air Trampoline Park, adventure awaits. Discover lush parks like LaFortune and Haikey Creek, or tap into nearby educational hubs such as Oral Roberts University. Experience a community rich in convenience!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Barrington Apartments in Tulsa, Oklahoma, luxury meets convenience. Choose from spacious one, two, or three-bedroom layouts, all equipped with modern amenities. Dive into relaxation at the pool, stay active in our fitness center, or enjoy quality time at the playground. Elevate your lifestyle and make Barrington home!",
  "property_applynow_blurb": "At Barrington Apartments in Tulsa, Oklahoma, choose from spacious one, two, or three-bedroom floor plans that suit your lifestyle. Enjoy luxury amenities like a refreshing pool, modern fitness center, and inviting picnic area. With on-site management and maintenance, your perfect home is just a click away. Lease online today!",
  "property_contactus_blurb": "At Barrington Apartments in Tulsa, Oklahoma, we offer an array of thoughtfully designed floor plans, including one, two, and three-bedroom options, tailored for modern living. Each space invites comfort and convenience. Curious about finding your perfect home? Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Barrington Apartments in Tulsa, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored for your lifestyle. Whether you seek comfort or space, our community has something for everyone. Visit our FAQs page to uncover the answers to your questions and learn more about your future home.",
  "property_floorplans_blurb": "At Barrington Apartments in Tulsa, Oklahoma, you'll find a variety of thoughtfully designed floor plans tailored for your lifestyle. Whether you desire a cozy one-bedroom, a spacious two-bedroom, or a family-friendly three-bedroom, each layout offers comfort and style. Browse our available apartment homes to find your ideal space today!",
  "property_gallery_blurb": "At Barrington Apartments in Tulsa, Oklahoma, elevate your lifestyle with our inviting one, two, and three-bedroom floor plans. Unwind by the sparkling pool, break a sweat in our fitness center, or enjoy family fun at the playground. Picture yourself living here, surrounded by modern comforts and vibrant community amenities!",
  "property_interactivemap_blurb": "Welcome to Barrington Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from spacious one, two, and three-bedroom layouts, each equipped with modern amenities like a fitness center, refreshing pool, and inviting picnic area. Navigate our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Barrington Apartments in vibrant Tulsa, OK, your furry friends are cherished! With space for two pets under 40 lbs, our community offers both comfort and convenience. Enjoy a serene lifestyle with a one-time pet fee of $500 and a monthly pet rent of just $25 per pet. Welcome home!",
  "property_referafriend_blurb": "At Barrington Apartments in Tulsa, Oklahoma, your perfect fit awaits! With one, two, and three-bedroom floor plans designed for comfort and elegance, our vibrant community thrives on friendship. Great friends make great neighbors—refer a friend today, and let them join you in this exceptional living experience!",
  "property_residentaccess_blurb": "Welcome to Barrington Apartments in Tulsa, Oklahoma! Choose from elegantly crafted one, two, and three-bedroom floor plans designed for your comfort. Stay connected with your home—access the resident portal to effortlessly pay rent, schedule maintenance, and enjoy more convenience at your fingertips. Join our community today!",
  "property_reviews_blurb": "At Barrington Apartments in Tulsa, residents appreciate our dedicated maintenance team. One tenant noted, \"The maintenance men are efficiently handling our work orders,\" ensuring your home remains both comfortable and safe. Join our vibrant community and see what our residents have to say about living at Barrington Apartments!",
  "property_created_at": "1753982377918",
  "property_scheduletour_blurb": "At Barrington Apartments in Tulsa, Oklahoma, choose from stylish one, two, or three-bedroom floor plans designed for modern living. Each space reflects comfort and elegance, perfect for making lasting memories. Curious about life here? Schedule a tour today and hear firsthand from our residents about their exceptional experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Barrington Apartments in Tulsa, Oklahoma! We can't wait to help you find your ideal living space among our thoughtfully designed one, two, and three-bedroom floor plans. A member of our team will connect with you soon to guide you on this exciting journey!",
  "property_virtualtours_blurb": "Welcome to Barrington Apartments in vibrant Tulsa, Oklahoma! Our beautifully designed one, two, and three-bedroom layouts offer the perfect blend of comfort and style. Ready to see your new home? Take a virtual tour of ourcommunity and discover your ideal apartment today!",
  "property_copyright": "2025 All Rights Reserved. Barrington Apartments",
  "property_seo_title_home": "Barrington Apartments |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Discover Barrington Apartments in Tulsa! Choose from 1-3 bedroom layouts, enjoy great amenities, and join a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Barrington Apartments in Tulsa! From cozy one-bedrooms to spacious three-bedrooms, browse our diverse floor plans today!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover a vibrant lifestyle at Barrington Apartments in Tulsa, OK, with luxurious amenities like a pool, fitness center, and spacious layouts!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Immersed in comfort and style, Barrington Apartments in Tulsa offers stunning spaces, vibrant amenities, and a welcoming community. Picture your new life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Barrington Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Barrington Apartments in Tulsa, OK! Take a virtual tour of our spacious one, two, and three-bedroom options that fit your lifestyle perfectly!",
  "property_seo_title_interactivemap": "Interactive Map | Barrington Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Barrington Apartments in Tulsa! Use our interactive map to explore spacious layouts, lifestyle amenities, and pricing that suits you!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Barrington Apartments in Tulsa. Dive into our vibrant neighborhood, filled with local gems and community favorites waiting to be explored!",
  "property_seo_title_contact": "Contact Us | Barrington Apartments",
  "property_seo_description_contact": "Elevate your lifestyle at Barrington Apartments in Tulsa! From chic one to spacious three-bedroom options, reach out today and let our leasing team assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Discover Barrington Apartments in Tulsa! Find answers on amenities, floor plans, and more in our FAQs for a seamless living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Join the Barrington Apartments family in Tulsa! Dive into resident reviews & discover spacious homes with top amenities like a pool, fitness center, & more!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Find your perfect fit at Barrington Apartments in Tulsa! Choose from spacious one, two, or three-bedroom homes with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Barrington Apartments",
  "property_seo_description_residentaccess": "Simplify life at Barrington Apartments, Tulsa! Use your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Barrington Apartments",
  "property_seo_description_referafriend": "Refer a friend to Barrington Apartments in Tulsa! Great friendships flourish here—enjoy vibrant living, community events, and cozy comforts together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Barrington Apartments",
  "property_seo_description_scheduletour": "Experience life at Barrington Apartments in Tulsa. Schedule a tour today and envision your new home in a vibrant community with modern amenities.",
  "property_seo_title_privacy": "Privacy Policy | Barrington Apartments",
  "property_seo_description_privacy": "Your privacy matters at Barrington Apartments in Tulsa. Learn how we safeguard your information and ensure a secure living experience. Read our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Barrington Apartments",
  "property_seo_description_accessibility": "At Barrington Apartments in Tulsa, we embrace digital inclusion, ensuring everyone can access our community. Experience a welcoming space designed for all!",
  "property_seo_title_sitemap": "Sitemap | Barrington Apartments",
  "property_seo_description_sitemap": "Uncover Barrington Apartments in Tulsa, OK—your gateway to a vibrant community. Check out our sitemap for a seamless living experience!",
  "property_seo_title_thankyou": "Thank You | Barrington Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! A Barrington Apartments team member will be in touch soon. Join us in Tulsa for the vibrant lifestyle you deserve!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864808972",
  "amenities": [
    {
      "id": "ec_73c8a58bb8083fc5cc829325",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396239",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74e212cce6248c6e8063f2e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396240",
      "title": "Fitness Center w/ Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c76f713cd682b27901c6d1ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396241",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d30ee495119ac61420f9d681",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396242",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d56a5276e267abc8f0d8834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396243",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_497c60edf8029fdf4550b334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396244",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5304e33c6fa6664caa8b504a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396245",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe25e06f9e03d1bd05d40e81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396247",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd9fe7ce1b598e6a0b0bdbee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396248",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9df6e5370ace6042daf1b7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396249",
      "title": "Picnic Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f24fdc9b5ac4701151fd36f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396250",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33010d1bbb42009afa1b9356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127396251",
      "title": "Union School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78a313dea5678793aad04f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "128017275",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96fb5758fc19fe45d89d2fc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397743",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d330bbb7815b3b82002f4cef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397745",
      "title": "Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc2d4016bd5f1119457e2f92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397746",
      "title": "Whirlpool Bath",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfd39bf01892b9cca07e00c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397747",
      "title": "Private Patio or Enclosed Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a4590f0ee89c7464222fc51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397748",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aaf66aa31d673b30696397bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397749",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_791b5b85e79276963e522142",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397750",
      "title": "Brick Fireplace w/Oak Mantel",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb9a4059e9028469478d951d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "yardi",
      "external_id": "127397751",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_50259c04-181f-4cb4-83ea-3b54dcc4c360",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-e93e-758a-bb5a-9f009819ebe6.webp",
      "image_media": {
        "alt_text": "A comfortable bedroom with a dark wood sleigh bed, matching dresser, nightstand, and ceiling fan.",
        "public_id": "019f04a2-e93e-758a-bb5a-9f009819ebe6",
        "storage_key": "property/6767906449165586/019f04a2-e93e-758a-bb5a-9f009819ebe6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in a cozy apartment bedroom featuring a stylish dark wood bed, matching furniture, and ample natural light.",
      "link": "",
      "alt_text": "A comfortable bedroom with a dark wood sleigh bed, matching dresser, nightstand, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcd005e8-da45-4ef2-8af4-56523b1e8641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-c389-7669-8942-465ce56b47df.webp",
      "image_media": {
        "alt_text": "Apartment kitchen featuring wood cabinets, black appliances, and a kitchen island. A living room and bedroom are visible.",
        "public_id": "019f04a2-c389-7669-8942-465ce56b47df",
        "storage_key": "property/6767906449165586/019f04a2-c389-7669-8942-465ce56b47df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a fully equipped kitchen featuring elegant wood cabinetry, modern black appliances, and a spacious island. Enjoy seamless transitions to comfortable living spaces.",
      "link": "",
      "alt_text": "Apartment kitchen featuring wood cabinets, black appliances, and a kitchen island. A living room and bedroom are visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16a114f6-34c9-40a8-8e97-e2ea15aa9143",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-be8d-7201-9131-953c1c480541.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances, wood cabinets, and countertops.",
        "public_id": "019f04a2-be8d-7201-9131-953c1c480541",
        "storage_key": "property/6767906449165586/019f04a2-be8d-7201-9131-953c1c480541.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A cozy kitchen featuring wood cabinetry, a black stove and microwave, and a view into a hallway with a cactus print and a washing machine.",
      "link": "",
      "alt_text": "Kitchen with black appliances, wood cabinets, and countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_04ec1872-b2a2-4cd2-9714-9d0376138d0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-bfb1-74ca-a08b-b12a4167e75e.webp",
      "image_media": {
        "alt_text": "In-unit stacked washer and dryer in a modern apartment laundry area with a decorative cactus picture on the wall.",
        "public_id": "019f04a2-bfb1-74ca-a08b-b12a4167e75e",
        "storage_key": "property/6767906449165586/019f04a2-bfb1-74ca-a08b-b12a4167e75e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the convenience of an in-unit stacked washer and dryer, making laundry day a breeze. This modern amenity is a standard feature in our apartments.",
      "link": "",
      "alt_text": "In-unit stacked washer and dryer in a modern apartment laundry area with a decorative cactus picture on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2a99eba-f1f1-4127-b017-2ee17f6b981e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-9945-705f-a465-4e526990c040.webp",
      "image_media": {
        "alt_text": "A bright kitchen with wooden cabinets, black appliances, light countertops, and wood-look flooring.",
        "public_id": "019f04a2-9945-705f-a465-4e526990c040",
        "storage_key": "property/6767906449165586/019f04a2-9945-705f-a465-4e526990c040.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cook up your favorite meals in this cozy kitchen featuring ample cabinet space, modern black appliances, and a convenient layout.",
      "link": "",
      "alt_text": "A bright kitchen with wooden cabinets, black appliances, light countertops, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69fc5669-e565-4349-9982-1d77c1d1ff39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-732b-71e0-b240-02c62f66cce6.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and kitchen counter.",
        "public_id": "019f04a2-732b-71e0-b240-02c62f66cce6",
        "storage_key": "property/6767906449165586/019f04a2-732b-71e0-b240-02c62f66cce6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a brick fireplace with a mounted TV, comfortable seating, and an adjacent kitchen area with bar stools.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, and kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1ec5091d-2a1d-49af-8599-9f73fe668372",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-5cfd-768f-8360-a40805a521b1.webp",
      "image_media": {
        "alt_text": "Bathroom with wood vanity, single sink, large mirror, and decorative wall art above.",
        "public_id": "019f04a2-5cfd-768f-8360-a40805a521b1",
        "storage_key": "property/6767906449165586/019f04a2-5cfd-768f-8360-a40805a521b1.webp",
        "width": 2049,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Step into our thoughtfully designed bathrooms featuring stylish wood vanities, ample counter space, and modern fixtures. Personalize your space with decorative accents and enjoy the comfort.",
      "link": "",
      "alt_text": "Bathroom with wood vanity, single sink, large mirror, and decorative wall art above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8b285bd-7492-453f-9f0a-c37bfc898903",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-bb9e-74d3-9d98-182c53538d9b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black refrigerator, wood cabinets, and a breakfast bar with pink bowls.",
        "public_id": "019f04a2-bb9e-74d3-9d98-182c53538d9b",
        "storage_key": "property/6767906449165586/019f04a2-bb9e-74d3-9d98-182c53538d9b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a convenient breakfast bar for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with black refrigerator, wood cabinets, and a breakfast bar with pink bowls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ca48ff5-1576-476c-8554-3ced7376c12b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-a88f-70ae-b654-78d58bcc8200.webp",
      "image_media": {
        "alt_text": "Kitchen island with breakfast bar and seating, facing living room.",
        "public_id": "019f04a2-a88f-70ae-b654-78d58bcc8200",
        "storage_key": "property/6767906449165586/019f04a2-a88f-70ae-b654-78d58bcc8200.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a breakfast bar with seating and a pass-through to the living area.",
      "link": "",
      "alt_text": "Kitchen island with breakfast bar and seating, facing living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa5b60c0-56cb-4d0e-9c3a-3b6fdac79c67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-5d02-7068-af89-bd5a1db6d1c2.webp",
      "image_media": {
        "alt_text": "Living room with a white sectional sofa, oval coffee table, and decorative mirrors on the wall.",
        "public_id": "019f04a2-5d02-7068-af89-bd5a1db6d1c2",
        "storage_key": "property/6767906449165586/019f04a2-5d02-7068-af89-bd5a1db6d1c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sectional sofa, a modern coffee table, and elegant wall decor. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a white sectional sofa, oval coffee table, and decorative mirrors on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_efe9be91-9bec-4fd1-a5fb-68285d93f8c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a2-5f45-717c-a515-8ae04ce3ed67.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace and a kitchen counter.",
        "public_id": "019f04a2-5f45-717c-a515-8ae04ce3ed67",
        "storage_key": "property/6767906449165586/019f04a2-5f45-717c-a515-8ae04ce3ed67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax by the fire in this inviting living space, complete with a full kitchen for your convenience.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace and a kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_deaab2ec-2b80-4e85-be5c-a19e124e2b23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a1-8e92-74a7-8b5b-b1a8a4f18c66.webp",
      "image_media": {
        "alt_text": "An apartment balcony with a small glass-top table and two chairs, offering views of green trees and surrounding residential homes.",
        "public_id": "019f04a1-8e92-74a7-8b5b-b1a8a4f18c66",
        "storage_key": "property/6767906449165586/019f04a1-8e92-74a7-8b5b-b1a8a4f18c66.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step out onto your private balcony, an ideal retreat for enjoying the fresh air and beautiful views. This inviting outdoor space is perfect for morning coffee, evening relaxation, or simply taking in the scenic surroundings.",
      "link": "",
      "alt_text": "An apartment balcony with a small glass-top table and two chairs, offering views of green trees and surrounding residential homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f03658d-0c44-4c37-8d31-ab076771712a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a1-64df-7598-a936-c5b6554eee77.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and artwork.",
        "public_id": "019f04a1-64df-7598-a936-c5b6554eee77",
        "storage_key": "property/6767906449165586/019f04a1-64df-7598-a936-c5b6554eee77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a vanity with a sink, mirror adorned with modern art, and a shower with a patterned curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70eb57a1-8dee-484e-8e3d-2b9ebeb9c38f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a1-1365-73ae-b1ed-70c82f3bed90.webp",
      "image_media": {
        "alt_text": "In-unit laundry closet with white washer and dryer, shelves, and a glimpse of a bathroom vanity to the left.",
        "public_id": "019f04a1-1365-73ae-b1ed-70c82f3bed90",
        "storage_key": "property/6767906449165586/019f04a1-1365-73ae-b1ed-70c82f3bed90.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, along with clever storage solutions, making laundry day a breeze. Some units also feature spacious bathrooms with ample counter space.",
      "link": "",
      "alt_text": "In-unit laundry closet with white washer and dryer, shelves, and a glimpse of a bathroom vanity to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_390ab295-74fc-4f4f-8096-13389e2ca4bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a1-1923-76b5-a3b8-8d5567a5ef67.webp",
      "image_media": {
        "alt_text": "Walk-in closet with built-in shelving and decorative wall art.",
        "public_id": "019f04a1-1923-76b5-a3b8-8d5567a5ef67",
        "storage_key": "property/6767906449165586/019f04a1-1923-76b5-a3b8-8d5567a5ef67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and a decorative touch with framed floral art, adding style and functionality to your living space.",
      "link": "",
      "alt_text": "Walk-in closet with built-in shelving and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc0d1352-ba9f-4009-aed9-a0299ce8f0ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a1-1a14-725b-9931-71ede4bbface.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, blue bedding, and decorative wall art.",
        "public_id": "019f04a1-1a14-725b-9931-71ede4bbface",
        "storage_key": "property/6767906449165586/019f04a1-1a14-725b-9931-71ede4bbface.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and tasteful decor.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, blue bedding, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7785cfa8-d0d3-43e2-a81e-541eabf95424",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a0-bf46-76dc-9a80-df272dedfa08.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a large bed, tufted headboard, two nightstands, a dresser, and a sliding glass door leading to a private patio.",
        "public_id": "019f04a0-bf46-76dc-9a80-df272dedfa08",
        "storage_key": "property/6767906449165586/019f04a0-bf46-76dc-9a80-df272dedfa08.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom featuring a comfortable bed with a stylish tufted headboard, ample storage, and direct access to your private outdoor patio for fresh air.",
      "link": "",
      "alt_text": "A cozy bedroom with a large bed, tufted headboard, two nightstands, a dresser, and a sliding glass door leading to a private patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_969bf00e-d9f9-4792-8c50-628262b92823",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f04a0-c41c-72ea-93ea-dd72e585c2a7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a sofa, coffee table, and counter seating.",
        "public_id": "019f04a0-c41c-72ea-93ea-dd72e585c2a7",
        "storage_key": "property/6767906449165586/019f04a0-c41c-72ea-93ea-dd72e585c2a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area flows into a functional kitchen, perfect for entertaining and everyday life.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with a sofa, coffee table, and counter seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72a93c60-9d1c-4d6c-9c9c-49dc3e7fd888",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-f5ac-72b1-bd68-f22511a2a5f9.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen-sized bed, tufted headboard, two nightstands with lamps, a dresser, and a sliding glass door leading to a balcony.",
        "public_id": "019f049e-f5ac-72b1-bd68-f22511a2a5f9",
        "storage_key": "property/6767906449165586/019f049e-f5ac-72b1-bd68-f22511a2a5f9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and recharge in this inviting bedroom, featuring plush carpeting, a modern ceiling fan, and access to a private balcony or patio through a sliding glass door.",
      "link": "",
      "alt_text": "Bright bedroom with a queen-sized bed, tufted headboard, two nightstands with lamps, a dresser, and a sliding glass door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f6ff1a67-fbb7-4e90-92b4-a52121f52bb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-c778-73ed-be7f-072f99ccaa91.webp",
      "image_media": {
        "alt_text": "Apartment kitchen with wood cabinets, white countertops, black appliances, stainless steel sink, and view of dining and bedroom.",
        "public_id": "019f049e-c778-73ed-be7f-072f99ccaa91",
        "storage_key": "property/6767906449165586/019f049e-c778-73ed-be7f-072f99ccaa91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment kitchen, complete with warm wood cabinetry, bright white countertops, a stainless steel sink, and sleek black appliances. The open design connects seamlessly to the dining area and a comfortable bedroom.",
      "link": "",
      "alt_text": "Apartment kitchen with wood cabinets, white countertops, black appliances, stainless steel sink, and view of dining and bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_974c17b2-e428-42c4-b401-84421695e0fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-7e58-7689-bb09-55ef8cb8f173.webp",
      "image_media": {
        "alt_text": "Living room with a brick fireplace, a TV, a sofa, and a coffee table.",
        "public_id": "019f049e-7e58-7689-bb09-55ef8cb8f173",
        "storage_key": "property/6767906449165586/019f049e-7e58-7689-bb09-55ef8cb8f173.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a rustic brick fireplace, a mounted television, comfortable seating with decorative pillows, and a stylish coffee table.",
      "link": "",
      "alt_text": "Living room with a brick fireplace, a TV, a sofa, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b907238-0228-46c2-8d79-88626a0af453",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-9838-7159-be31-cf6f773f788e.webp",
      "image_media": {
        "alt_text": "A dining area with a round table and four chairs, illuminated by a modern pendant light. Wall shelves and abstract art adorn the beige wall.",
        "public_id": "019f049e-9838-7159-be31-cf6f773f788e",
        "storage_key": "property/6767906449165586/019f049e-9838-7159-be31-cf6f773f788e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, featuring a stylish round table and comfortable seating. The space is enhanced by a contemporary light fixture and elegant wall decor.",
      "link": "",
      "alt_text": "A dining area with a round table and four chairs, illuminated by a modern pendant light. Wall shelves and abstract art adorn the beige wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0849df98-d7ce-4f85-b710-1b62be92e06f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-871d-76de-ada1-8d040ad41073.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, and two framed abstract art pieces on the wall.",
        "public_id": "019f049e-871d-76de-ada1-8d040ad41073",
        "storage_key": "property/6767906449165586/019f049e-871d-76de-ada1-8d040ad41073.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this cozy living room featuring a plush sofa, decorative accents, and modern art. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Living room with a couch, coffee table, and two framed abstract art pieces on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8146a840-34e4-44a6-ad90-0905fcf3c277",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-45db-769f-95cc-e1131334bed1.webp",
      "image_media": {
        "alt_text": "Fitness center with exercise balls, kettlebells, and an elliptical machine.",
        "public_id": "019f049e-45db-769f-95cc-e1131334bed1",
        "storage_key": "property/6767906449165586/019f049e-45db-769f-95cc-e1131334bed1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of equipment including exercise balls, kettlebells, and cardio machines for a comprehensive workout.",
      "link": "",
      "alt_text": "Fitness center with exercise balls, kettlebells, and an elliptical machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_10eac0f3-a876-4614-baa1-08ff236aea10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-1f9c-712c-baf8-d87f94e8cbe7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and weight bench.",
        "public_id": "019f049e-1f9c-712c-baf8-d87f94e8cbe7",
        "storage_key": "property/6767906449165586/019f049e-1f9c-712c-baf8-d87f94e8cbe7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring treadmills, an elliptical, a stationary bike, and a weight bench for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_792ad04a-2b99-4d42-9531-5dd69fd562c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-27bd-759a-99fa-9380c0dea767.webp",
      "image_media": {
        "alt_text": "Interior view of the community fitness center with treadmills, ellipticals, exercise balls, and free weights.",
        "public_id": "019f049e-27bd-759a-99fa-9380c0dea767",
        "storage_key": "property/6767906449165586/019f049e-27bd-759a-99fa-9380c0dea767.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio machines, strength training equipment, and free weights to help you achieve your health and wellness goals.",
      "link": "",
      "alt_text": "Interior view of the community fitness center with treadmills, ellipticals, exercise balls, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_899f36ee-675a-472d-9d18-3dac73510b22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-52e9-7675-99cf-1b6ae45398fb.webp",
      "image_media": {
        "alt_text": "Barrington Apartments monument sign",
        "public_id": "019f049e-52e9-7675-99cf-1b6ae45398fb",
        "storage_key": "property/6767906449165586/019f049e-52e9-7675-99cf-1b6ae45398fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Barrington Apartments, a premier multifamily property with a distinguished monument sign.",
      "link": "",
      "alt_text": "Barrington Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6caac318-5fd8-488a-87dc-f09f846f3643",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049d-eab6-7244-9b3d-ab49d0e1608c.webp",
      "image_media": {
        "alt_text": "Exterior view of white townhome-style apartment buildings with dark trim and grassy lawn under a blue sky.",
        "public_id": "019f049d-eab6-7244-9b3d-ab49d0e1608c",
        "storage_key": "property/6767906449165586/019f049d-eab6-7244-9b3d-ab49d0e1608c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience the charming exterior of our community, featuring modern white townhome-style buildings, lush green lawns, and inviting entrances under a bright sky.",
      "link": "",
      "alt_text": "Exterior view of white townhome-style apartment buildings with dark trim and grassy lawn under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_950df218-46d7-4a10-a3f6-320b5bc1720a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049d-b043-725f-9164-2fdde8888204.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with convenient covered parking spaces and lush landscaping under a blue sky.",
        "public_id": "019f049d-b043-725f-9164-2fdde8888204",
        "storage_key": "property/6767906449165586/019f049d-b043-725f-9164-2fdde8888204.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience hassle-free parking with our dedicated covered spaces, offering protection for your vehicle. Our charming community exteriors blend comfort and style.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with convenient covered parking spaces and lush landscaping under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1dd2ae8-773c-48b2-a30c-9468756e6586",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049d-b0a2-776a-9572-1ae27b12a47e.webp",
      "image_media": {
        "alt_text": "Exterior view of modern townhouse-style apartment buildings with white siding, stone accents, black trim, and green lawns.",
        "public_id": "019f049d-b0a2-776a-9572-1ae27b12a47e",
        "storage_key": "property/6767906449165586/019f049d-b0a2-776a-9572-1ae27b12a47e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience charming living in our townhouse-style apartments featuring modern white exteriors, rustic stone accents, and well-maintained green spaces. Enjoy the serene community atmosphere and beautiful surroundings.",
      "link": "",
      "alt_text": "Exterior view of modern townhouse-style apartment buildings with white siding, stone accents, black trim, and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2aa5f5ee-cd52-4416-8630-d50ff7228354",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049d-b17f-77af-b97c-43fcb24bc14c.webp",
      "image_media": {
        "alt_text": "Community playground with swings, slides, and a spinning globe, surrounded by apartment buildings and covered parking on a sunny day.",
        "public_id": "019f049d-b17f-77af-b97c-43fcb24bc14c",
        "storage_key": "property/6767906449165586/019f049d-b17f-77af-b97c-43fcb24bc14c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community playground, featuring swings, slides, and a fun spinning globe, perfect for families. Our property also offers convenient covered parking right outside your apartment home.",
      "link": "",
      "alt_text": "Community playground with swings, slides, and a spinning globe, surrounded by apartment buildings and covered parking on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54c8da43-5602-4651-840b-5aa0c6e9e780",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049d-af66-7686-863e-3745054611c2.webp",
      "image_media": {
        "alt_text": "Exterior view of modern apartment buildings with white siding, brick accents, green lawns, and walkways under a blue sky.",
        "public_id": "019f049d-af66-7686-863e-3745054611c2",
        "storage_key": "property/6767906449165586/019f049d-af66-7686-863e-3745054611c2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover charming community living. Our modern apartment exteriors feature a mix of white siding and classic brick, complemented by lush green lawns and convenient walkways, all under a bright blue sky.",
      "link": "",
      "alt_text": "Exterior view of modern apartment buildings with white siding, brick accents, green lawns, and walkways under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9513d191-7f18-4cd3-941e-4aef58d1d03d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049d-b0cb-7405-8de5-d28568ea4b2b.webp",
      "image_media": {
        "alt_text": "Playground with swings and climbing structure, picnic table, and grill area.",
        "public_id": "019f049d-b0cb-7405-8de5-d28568ea4b2b",
        "storage_key": "property/6767906449165586/019f049d-b0cb-7405-8de5-d28568ea4b2b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with our community playground, featuring swings, a climbing structure, a picnic table, and a grill area for resident gatherings.",
      "link": "",
      "alt_text": "Playground with swings and climbing structure, picnic table, and grill area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa7fb819-fec5-4925-b395-13939af09be0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-c023-732c-8984-ba2126d0150a.webp",
      "image_media": {
        "alt_text": "Fenced dog park with red tunnel, blue ramp, blue platform, and hoops on green grass. Trees & apartment buildings in background.",
        "public_id": "019f049b-c023-732c-8984-ba2126d0150a",
        "storage_key": "property/6767906449165586/019f049b-c023-732c-8984-ba2126d0150a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Your furry friends will love our spacious, fenced-in pet park! It features various agility equipment like a tunnel, ramp, and hoops, providing a fun and safe space for them to play and exercise outdoors.",
      "link": "",
      "alt_text": "Fenced dog park with red tunnel, blue ramp, blue platform, and hoops on green grass. Trees & apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_335f7061-a1f1-467b-b332-241ab3b71366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-addf-758e-817a-655a17528589.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including tunnels, ramps, and a table.",
        "public_id": "019f049b-addf-758e-817a-655a17528589",
        "storage_key": "property/6767906449165586/019f049b-addf-758e-817a-655a17528589.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our community dog park provides a safe and fun space for your furry friends to play and exercise with various agility obstacles.",
      "link": "",
      "alt_text": "Dog park with agility equipment including tunnels, ramps, and a table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6640a90-f77d-49b8-a0cf-1c09dd842862",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-73f2-73bd-b63d-80183b82bc01.webp",
      "image_media": {
        "alt_text": "Vibrant green community courtyard with a playground, basketball hoop, and apartment buildings under a blue sky.",
        "public_id": "019f049b-73f2-73bd-b63d-80183b82bc01",
        "storage_key": "property/6767906449165586/019f049b-73f2-73bd-b63d-80183b82bc01.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor community area, featuring a vibrant green lawn, fun playground for kids, and a basketball hoop for active recreation. Perfect for residents to relax and play.",
      "link": "",
      "alt_text": "Vibrant green community courtyard with a playground, basketball hoop, and apartment buildings under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bbb1c657-2d78-46ba-b63d-29ae1e3c9917",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-90f6-71c8-a52d-3389ec172c7f.webp",
      "image_media": {
        "alt_text": "A colorful playground with a blue roof and orange slide in a large grassy courtyard, surrounded by apartment buildings.",
        "public_id": "019f049b-90f6-71c8-a52d-3389ec172c7f",
        "storage_key": "property/6767906449165586/019f049b-90f6-71c8-a52d-3389ec172c7f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our community features a fun playground in a spacious green area, providing a perfect spot for children to play and residents to relax outdoors.",
      "link": "",
      "alt_text": "A colorful playground with a blue roof and orange slide in a large grassy courtyard, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a05ae35-8f1e-4b22-9e37-8da9a30b1390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-c25a-7668-896c-7f1f70f349dc.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, including a tunnel, ramp, and weave poles.",
        "public_id": "019f049b-c25a-7668-896c-7f1f70f349dc",
        "storage_key": "property/6767906449165586/019f049b-c25a-7668-896c-7f1f70f349dc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our pet-friendly community features a dedicated dog park with agility equipment for your furry friends to enjoy.",
      "link": "",
      "alt_text": "Dog park with agility equipment, including a tunnel, ramp, and weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c45b7c93-f2a3-46b7-b914-93461c049152",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-75c4-76fc-8f12-cda5276e4e05.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court and colorful playground set against a backdrop of apartment buildings on a sunny day.",
        "public_id": "019f049b-75c4-76fc-8f12-cda5276e4e05",
        "storage_key": "property/6767906449165586/019f049b-75c4-76fc-8f12-cda5276e4e05.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our community features a dedicated basketball court and a fun, colorful playground, perfect for residents of all ages to enjoy outdoor activities and socialize.",
      "link": "",
      "alt_text": "Outdoor basketball court and colorful playground set against a backdrop of apartment buildings on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fa3081e-749e-4668-9e31-5d1dec2363bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-6a39-708e-825d-cbd2a417551f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with bright blue water and lounge chairs under a clear sky, surrounded by apartment buildings and green trees.",
        "public_id": "019f049b-6a39-708e-825d-cbd2a417551f",
        "storage_key": "property/6767906449165586/019f049b-6a39-708e-825d-cbd2a417551f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind at our sparkling outdoor swimming pool, perfect for soaking up the sun on a beautiful day. Enjoy comfortable lounge seating and a refreshing dip just steps from your home.",
      "link": "",
      "alt_text": "Outdoor swimming pool with bright blue water and lounge chairs under a clear sky, surrounded by apartment buildings and green trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3893eedd-0107-4a0c-be24-f96fe7868f42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-84bc-7726-bcfd-1cbb3966488e.webp",
      "image_media": {
        "alt_text": "Basketball court and playground area on a sunny day with apartment buildings in the background.",
        "public_id": "019f049b-84bc-7726-bcfd-1cbb3966488e",
        "storage_key": "property/6767906449165586/019f049b-84bc-7726-bcfd-1cbb3966488e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with our on-site basketball court and playground, perfect for staying active and having fun.",
      "link": "",
      "alt_text": "Basketball court and playground area on a sunny day with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ee440bde-cc71-4ff1-9a79-6c62dc9d8a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-4413-753a-aab0-b5cd59c8dd9e.webp",
      "image_media": {
        "alt_text": "Community swimming pool with turquoise water, lounge chairs on a sunny day. Apartment buildings and trees in background.",
        "public_id": "019f049b-4413-753a-aab0-b5cd59c8dd9e",
        "storage_key": "property/6767906449165586/019f049b-4413-753a-aab0-b5cd59c8dd9e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our refreshing community swimming pool, featuring comfortable lounge chairs for sunbathing and a vibrant atmosphere. Perfect for a cool dip on a warm day or simply enjoying the outdoors.",
      "link": "",
      "alt_text": "Community swimming pool with turquoise water, lounge chairs on a sunny day. Apartment buildings and trees in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_698852dc-fbd5-4ca8-9fd6-ca76bd7a20c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-35da-7444-93ce-28d22a3acd46.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019f049b-35da-7444-93ce-28d22a3acd46",
        "storage_key": "property/6767906449165586/019f049b-35da-7444-93ce-28d22a3acd46.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38b5bcd5-e864-4cc9-b070-39c9b6dd8af1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049a-a175-747a-adba-8f63d4edfd83.webp",
      "image_media": {
        "alt_text": "Community lounge area with seating, a computer desk with chairs, and a TV displaying a scenic landscape.",
        "public_id": "019f049a-a175-747a-adba-8f63d4edfd83",
        "storage_key": "property/6767906449165586/019f049a-a175-747a-adba-8f63d4edfd83.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and work in our community lounge, equipped with comfortable seating, a computer station, and entertainment.",
      "link": "",
      "alt_text": "Community lounge area with seating, a computer desk with chairs, and a TV displaying a scenic landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de2c3c89-e264-4e23-9ba6-68c5b69ebe23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049a-a3c1-75bd-b7ab-5900358fff5d.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a fireplace and seating area.",
        "public_id": "019f049a-a3c1-75bd-b7ab-5900358fff5d",
        "storage_key": "property/6767906449165586/019f049a-a3c1-75bd-b7ab-5900358fff5d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in the comfortable community lounge, featuring a cozy fireplace and ample seating.",
      "link": "",
      "alt_text": "Spacious community lounge with a fireplace and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_71ed76b3-15c8-4f58-9393-93e125256e62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6a7e-770f-b8b6-988552105d93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6a7e-770f-b8b6-988552105d93",
        "storage_key": "property/6767906449165586/019cfb39-6a7e-770f-b8b6-988552105d93.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b954fbb1-09a7-4e5e-af0f-1d0c019427f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6d48-70be-bf96-a3096332ab59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6d48-70be-bf96-a3096332ab59",
        "storage_key": "property/6767906449165586/019cfb39-6d48-70be-bf96-a3096332ab59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_09f507c9-4600-4780-a071-2a0beac98b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6a7e-770f-b8b6-9db32a5cd5f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6a7e-770f-b8b6-9db32a5cd5f9",
        "storage_key": "property/6767906449165586/019cfb39-6a7e-770f-b8b6-9db32a5cd5f9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_07d7fc92-3d2b-4961-af94-026eba760566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6a59-756b-b6e5-94d62bc86855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6a59-756b-b6e5-94d62bc86855",
        "storage_key": "property/6767906449165586/019cfb39-6a59-756b-b6e5-94d62bc86855.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1014b896-4eb3-4b0e-95a5-fcf5495a85e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6cc4-72ce-bf17-932f54fe6c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6cc4-72ce-bf17-932f54fe6c6d",
        "storage_key": "property/6767906449165586/019cfb39-6cc4-72ce-bf17-932f54fe6c6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b84ece25-5537-43e9-aac0-49ed3a8fcb33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6e9f-7630-8939-92e083f097ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6e9f-7630-8939-92e083f097ee",
        "storage_key": "property/6767906449165586/019cfb39-6e9f-7630-8939-92e083f097ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9142baf8-d4a9-4e52-a1e5-53ab1c3f3eb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6d28-73ba-8c3e-7a884b951a15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6d28-73ba-8c3e-7a884b951a15",
        "storage_key": "property/6767906449165586/019cfb39-6d28-73ba-8c3e-7a884b951a15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-825a-77ed-a27f-e3a79f08a18b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-825a-77ed-a27f-e3a79f08a18b",
        "storage_key": "property/6767906449165586/019cfb39-825a-77ed-a27f-e3a79f08a18b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cb49e360-827b-4d2f-9b51-409c2f4473bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 E 41st St, Tulsa, OK 74105, USA",
      "poi_short_description": "Grocery store showcasing organic products and gluten-free options alongside prepared foods and salad bars.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, specialty items, and pre-made meals. They also highlight the clean and well-stocked store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6aa4-741c-9db8-bb53bc9833be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6aa4-741c-9db8-bb53bc9833be",
        "storage_key": "property/6767906449165586/019cfb39-6aa4-741c-9db8-bb53bc9833be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/brookside?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14383884403839006292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.104878",
      "poi_longitude": "-95.9732615",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-712-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-825a-77ed-a27f-e3a79f08a18b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-825a-77ed-a27f-e3a79f08a18b",
        "storage_key": "property/6767906449165586/019cfb39-825a-77ed-a27f-e3a79f08a18b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5_NEVCTtocRVPYa_afSncc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_21bc2bb5-aa78-4012-9ed0-8842887cb4d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6cd6-725b-adca-1362e33ab2ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6cd6-725b-adca-1362e33ab2ba",
        "storage_key": "property/6767906449165586/019cfb39-6cd6-725b-adca-1362e33ab2ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-825a-77ed-a27f-e3a79f08a18b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-825a-77ed-a27f-e3a79f08a18b",
        "storage_key": "property/6767906449165586/019cfb39-825a-77ed-a27f-e3a79f08a18b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_f8c75961-ce1a-42fc-8f07-32d3df0117bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1525 S Yale Ave, Tulsa, OK 74112, USA",
      "poi_short_description": "Chain hardware store and home center stocked with lawn equipment, appliances, paint and patio furniture.",
      "poi_long_description": "People say this home improvement store offers a wide selection of appliances and DIY products. They also highlight the helpful staff and quick checkout.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6a7e-770f-b8b6-971804475a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6a7e-770f-b8b6-971804475a3a",
        "storage_key": "property/6767906449165586/019cfb39-6a7e-770f-b8b6-971804475a3a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Tulsa/1580?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1580-_-na-_-0-_-0&y_source=1_MTE4NDQwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278391127478819263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.1396197",
      "poi_longitude": "-95.9196011",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-712-8199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcRFpChXttocRv9muPq2bZao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c2000848-251d-41b1-80fa-6b3a59568a2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-70f6-718f-aac3-87f015a9bd84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-70f6-718f-aac3-87f015a9bd84",
        "storage_key": "property/6767906449165586/019cfb39-70f6-718f-aac3-87f015a9bd84.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7a86a2e9-556c-41bf-b9f4-83a2f7cb2e52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-70ce-752b-849f-490d57eb687b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-70ce-752b-849f-490d57eb687b",
        "storage_key": "property/6767906449165586/019cfb39-70ce-752b-849f-490d57eb687b.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1ba8c10a-7887-4c6f-9570-94dcb87a47ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6fb2-754c-bf6e-4f2cd4771d65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6fb2-754c-bf6e-4f2cd4771d65",
        "storage_key": "property/6767906449165586/019cfb39-6fb2-754c-bf6e-4f2cd4771d65.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5fd1149b-7ffa-42d0-890e-c50769697e22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-70ba-734b-8be8-3598d2adaa7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-70ba-734b-8be8-3598d2adaa7c",
        "storage_key": "property/6767906449165586/019cfb39-70ba-734b-8be8-3598d2adaa7c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6eecab1d-40f5-437d-a2ca-985252da2a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-70ea-779b-b8e1-84ff1e26cd90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-70ea-779b-b8e1-84ff1e26cd90",
        "storage_key": "property/6767906449165586/019cfb39-70ea-779b-b8e1-84ff1e26cd90.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_aca12c30-5fb2-46fe-bcdd-4e4c8c8ca3d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-727f-775b-91f7-0d781c363d86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-727f-775b-91f7-0d781c363d86",
        "storage_key": "property/6767906449165586/019cfb39-727f-775b-91f7-0d781c363d86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_bf4c92ee-e642-4b8f-be6a-80014d7fe819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-72e1-712a-83c7-3a9a75c3dc62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-72e1-712a-83c7-3a9a75c3dc62",
        "storage_key": "property/6767906449165586/019cfb39-72e1-712a-83c7-3a9a75c3dc62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_f3451102-0957-4e05-ace1-c8738d67ac00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Golden Driller Statue",
      "poi_type": "Entertainment",
      "poi_address": "Tulsa Expo Center, 4145 E 21st St, Tulsa, OK 74114, USA",
      "poi_short_description": "Golden, roadside landmark, built in 1953 in Tulsa, of an oil worker (nicknamed “the Driller”), 75 feet tall, adorned with a T-shirt, representing a time when the town was known as the “oil capital of the world”.",
      "poi_long_description": "Visitors say this historical landmark is a must-see, especially for those from out of town, and they praise the statue's impressive size. They also highlight that parking is free and it's a great place to stop for photos, especially during events like the Tulsa State Fair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-729f-7139-990f-388c38b33c1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-729f-7139-990f-388c38b33c1a",
        "storage_key": "property/6767906449165586/019cfb39-729f-7139-990f-388c38b33c1a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://exposquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14322764790652212651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-driller-statue",
      "poi_latitude": "36.1337734",
      "poi_longitude": "-95.9311081",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-596-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswh6RCPttocRqxVMHLGuxMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_1a7fcaaf-2a62-4d8f-8c46-ae57fc1fa456",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-72db-7796-bab8-e875e5c1050e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-72db-7796-bab8-e875e5c1050e",
        "storage_key": "property/6767906449165586/019cfb39-72db-7796-bab8-e875e5c1050e.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_31322f4e-de3a-45ce-8d71-d100a58c1804",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-745d-73f0-886b-7be0bd25cd63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-745d-73f0-886b-7be0bd25cd63",
        "storage_key": "property/6767906449165586/019cfb39-745d-73f0-886b-7be0bd25cd63.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_19c39305-61e2-4dc7-9e8d-9283986ea7df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-75da-720b-b76d-2afd95cace18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-75da-720b-b76d-2afd95cace18",
        "storage_key": "property/6767906449165586/019cfb39-75da-720b-b76d-2afd95cace18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d022eff2-5a41-4757-a2c9-ecec60afacfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-75ba-735b-8ec7-6f0d4a111323.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-75ba-735b-8ec7-6f0d4a111323",
        "storage_key": "property/6767906449165586/019cfb39-75ba-735b-8ec7-6f0d4a111323.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a40a480f-45f2-49a7-9937-2a8fcf70218a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-74ca-74d6-94ed-bf53a107b1ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-74ca-74d6-94ed-bf53a107b1ce",
        "storage_key": "property/6767906449165586/019cfb39-74ca-74d6-94ed-bf53a107b1ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_beb274bf-cbdf-4dbc-870e-139c195255b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-75c4-706f-aa7a-80a73e32f91f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-75c4-706f-aa7a-80a73e32f91f",
        "storage_key": "property/6767906449165586/019cfb39-75c4-706f-aa7a-80a73e32f91f.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_7d0470d2-3525-404a-bcd5-243c01d0e955",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "9142 E 31st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Gym offering cardio and strength-training equipment, as well as Pilates, yoga, and cycling classes.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including free weights, machines, and cardio options, as well as classes and tanning booths. They highlight the clean facilities, spacious layout, and 24/7 availability, making it convenient for people with unpredictable schedules. They also like the friendly, helpful, and understanding staff, and the welcoming, non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7794-758f-8dfb-580e08684469.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7794-758f-8dfb-580e08684469",
        "storage_key": "property/6767906449165586/019cfb39-7794-758f-8dfb-580e08684469.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/east-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362762748097342813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.1175059",
      "poi_longitude": "-95.8708861",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-438-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4own9SMtocRXS1WmAY2FOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d4d610d5-3d00-4047-b026-61561f43b907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-782b-709d-a026-185ea3150e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-782b-709d-a026-185ea3150e81",
        "storage_key": "property/6767906449165586/019cfb39-782b-709d-a026-185ea3150e81.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7bb9f60e-5006-4581-9af2-3c209389ad1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7831-700a-b7fd-3651493bcd19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7831-700a-b7fd-3651493bcd19",
        "storage_key": "property/6767906449165586/019cfb39-7831-700a-b7fd-3651493bcd19.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8273-7129-9335-3d334b03a91d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8273-7129-9335-3d334b03a91d",
        "storage_key": "property/6767906449165586/019cfb39-8273-7129-9335-3d334b03a91d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7dac5bd5-e27e-4873-8e0a-7055f31e011f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7919-7677-b7fc-870f9fc9b64c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7919-7677-b7fc-870f9fc9b64c",
        "storage_key": "property/6767906449165586/019cfb39-7919-7677-b7fc-870f9fc9b64c.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8273-7129-9335-3d334b03a91d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8273-7129-9335-3d334b03a91d",
        "storage_key": "property/6767906449165586/019cfb39-8273-7129-9335-3d334b03a91d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2f209f2a-7008-464a-8451-42ac4cdfe2fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-791d-72e7-b3d5-9a5555c3474d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-791d-72e7-b3d5-9a5555c3474d",
        "storage_key": "property/6767906449165586/019cfb39-791d-72e7-b3d5-9a5555c3474d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-834c-7551-91c8-4b9b24b73d3c",
        "storage_key": "property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_438235a0-29cc-4761-b288-20442662e584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-79ed-74e9-8f54-9d7b9bfb3e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-79ed-74e9-8f54-9d7b9bfb3e89",
        "storage_key": "property/6767906449165586/019cfb39-79ed-74e9-8f54-9d7b9bfb3e89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-834c-7551-91c8-4b9b24b73d3c",
        "storage_key": "property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df502430-2e3c-4d12-89b8-8e5017b6f634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7a64-761e-8375-af9d821fdb3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7a64-761e-8375-af9d821fdb3b",
        "storage_key": "property/6767906449165586/019cfb39-7a64-761e-8375-af9d821fdb3b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-834c-7551-91c8-4b9b24b73d3c",
        "storage_key": "property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0b4c1260-bb68-4bfe-bc5a-f33edf350541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7c1a-725f-96eb-f45a347cfe99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7c1a-725f-96eb-f45a347cfe99",
        "storage_key": "property/6767906449165586/019cfb39-7c1a-725f-96eb-f45a347cfe99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-834c-7551-91c8-4b9b24b73d3c",
        "storage_key": "property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_137bf59a-0d8c-4818-af5b-2b6e698b99e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7bd9-771f-b34d-2636f2a720aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7bd9-771f-b34d-2636f2a720aa",
        "storage_key": "property/6767906449165586/019cfb39-7bd9-771f-b34d-2636f2a720aa.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-834c-7551-91c8-4b9b24b73d3c",
        "storage_key": "property/6767906449165586/019cfb39-834c-7551-91c8-4b9b24b73d3c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9f1282b-c574-4333-acb1-a274257a33fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7bfd-75bc-ab9e-61412ad65298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7bfd-75bc-ab9e-61412ad65298",
        "storage_key": "property/6767906449165586/019cfb39-7bfd-75bc-ab9e-61412ad65298.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-832e-7008-97af-5cd798ee9e3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-832e-7008-97af-5cd798ee9e3c",
        "storage_key": "property/6767906449165586/019cfb39-832e-7008-97af-5cd798ee9e3c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_925f863d-6372-4c7a-b042-48dec29ec627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7d51-731d-90f2-2d46caf01195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7d51-731d-90f2-2d46caf01195",
        "storage_key": "property/6767906449165586/019cfb39-7d51-731d-90f2-2d46caf01195.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cad51974-4fc4-438e-92b7-929b18403ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7c73-77a8-9b0c-cda3d0c20e7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7c73-77a8-9b0c-cda3d0c20e7f",
        "storage_key": "property/6767906449165586/019cfb39-7c73-77a8-9b0c-cda3d0c20e7f.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c1af413d-da35-4ae6-80a4-ec48e528197f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7d51-731d-90f2-2a8c53ff48a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7d51-731d-90f2-2a8c53ff48a9",
        "storage_key": "property/6767906449165586/019cfb39-7d51-731d-90f2-2a8c53ff48a9.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c950809b-81df-4ae0-8166-f4f17f10ddcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9660960d-3ba2-4227-84a4-f763062e6095",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-7dc0-778a-911f-dd30173e7972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-7dc0-778a-911f-dd30173e7972",
        "storage_key": "property/6767906449165586/019cfb39-7dc0-778a-911f-dd30173e7972.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c46364ba-b42c-41d0-b7a8-ae649d7d8078",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Jarman Elementary School",
      "poi_type": "Education",
      "poi_address": "9015 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://unionps.org/index.php?pageID=426682_3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15163329848068604185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jarman-elementary-school",
      "poi_latitude": "36.0504608",
      "poi_longitude": "-95.8761305",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-357-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-clnx8GNtocRGQE1dij4btI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_044fdf95-be5a-4af6-97f4-73f9a2c7c2cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-b161-72e6-ae53-4a4372792a17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b161-72e6-ae53-4a4372792a17",
        "storage_key": "property/6767906449165586/019d7911-b161-72e6-ae53-4a4372792a17.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9ec4f073-e861-4747-8ee3-1d2cf0bd4f5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Tulsa Tech",
      "poi_type": "Education",
      "poi_address": "3638 S Memorial Dr, Tulsa, OK 74145, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-b79b-754f-817e-f042d1716996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b79b-754f-817e-f042d1716996",
        "storage_key": "property/6767906449165586/019d7911-b79b-754f-817e-f042d1716996.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tulsatech.edu/?utm_source=google+my+business&utm_medium=search&utm_campaign=Tulsa+Tech&utm_id=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=10799165824243800343&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-tech",
      "poi_latitude": "36.11104419999999",
      "poi_longitude": "-95.8876766",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-828-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgUmoS06NtocRFxmXyBlY3pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_2aebf062-6c83-4862-bf4f-94ea7ab32cbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Clary Sage College",
      "poi_type": "Education",
      "poi_address": "3131 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-b1c9-7039-8af9-686dfe1e3ac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b1c9-7039-8af9-686dfe1e3ac0",
        "storage_key": "property/6767906449165586/019d7911-b1c9-7039-8af9-686dfe1e3ac0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://clarysagecollege.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13907947766092128129&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clary-sage-college",
      "poi_latitude": "36.1170274",
      "poi_longitude": "-95.9040243",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-298-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_aTKSKuStocRgd-bSM70AsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_a5ecd4dd-80e1-4921-8afe-693b6eb1e2e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-b2c3-775c-b69f-4daa31288694.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b2c3-775c-b69f-4daa31288694",
        "storage_key": "property/6767906449165586/019d7911-b2c3-775c-b69f-4daa31288694.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82b3-744f-8722-31a5edb60f63",
        "storage_key": "property/6767906449165586/019cfb39-82b3-744f-8722-31a5edb60f63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d62aee59-a097-4a7e-95be-daf56855f319",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Silver Skillet Family Diner",
      "poi_type": "Restaurants",
      "poi_address": "8228 E 61st St suite 114, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual restaurant serving homestyle breakfast and American comfort fare such as chicken fried steak and cinnamon rolls.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, skillets, and cinnamon rolls. They highlight the generous portions, reasonable prices, and friendly staff. They also like the clean and comfortable atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-ba1d-748b-a875-0477082f0419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ba1d-748b-a875-0477082f0419",
        "storage_key": "property/6767906449165586/019d7911-ba1d-748b-a875-0477082f0419.webp",
        "width": 850,
        "height": 443
      },
      "poi_business_url": "https://silverskilletfamilydiner.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2927847794226530013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "silver-skillet-family-diner",
      "poi_latitude": "36.0744018",
      "poi_longitude": "-95.8847332",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-940-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3a1lZ2NtocR3YZIcw7OoSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c05f471a-5f64-4b86-beae-d191a9baed3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Jason's Deli",
      "poi_type": "Restaurants",
      "poi_address": "8321 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_long_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-bc8e-77ae-9aa8-6ff686365361.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bc8e-77ae-9aa8-6ff686365361",
        "storage_key": "property/6767906449165586/019d7911-bc8e-77ae-9aa8-6ff686365361.webp",
        "width": 1142,
        "height": 876
      },
      "poi_business_url": "https://www.jasonsdeli.com/locations/ok/tulsa/8321-ne-61st-st/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17611070890146406872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jason-s-deli",
      "poi_latitude": "36.0761506",
      "poi_longitude": "-95.8835391",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-252-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRz7MHaNtocR2CFmyaoXZ_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d07165b1-9a44-4ffb-9b59-a1546d36127a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "9815 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "People say this Chinese restaurant serves fresh food with delicious flavors, and the staff can be friendly.\n\nOther reviews mention the service can be slow and the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-bf39-73dd-b150-05f366cc5a87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bf39-73dd-b150-05f366cc5a87",
        "storage_key": "property/6767906449165586/019d7911-bf39-73dd-b150-05f366cc5a87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/ok/tulsa/1808?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=15824850730546783352&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "36.0613691",
      "poi_longitude": "-95.8671103",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-459-0315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZAhpLCNtocReGTSUeUpnds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_5206bbf6-627d-4659-b093-19834ca7b1b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "El Chico Cafe",
      "poi_type": "Restaurants",
      "poi_address": "9705 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Longtime, kid-friendly chain serving Tex-Mex staples & margaritas in a colorful space.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious Tex-Mex food, including tasty salsa and queso, and tortilla soup. They also highlight the great atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-c40c-76fd-b176-b613f7649048.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c40c-76fd-b176-b613f7649048",
        "storage_key": "property/6767906449165586/019d7911-c40c-76fd-b176-b613f7649048.webp",
        "width": 640,
        "height": 542
      },
      "poi_business_url": "http://www.elchico.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15133411940806718478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-chico-cafe",
      "poi_latitude": "36.0612868",
      "poi_longitude": "-95.8679168",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-252-9442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZ0qDrqNtocRDnRw2_qtBNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ced279bf-2e3d-4d67-a135-c00d57d992dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "F's Hawaiian Food",
      "poi_type": "Restaurants",
      "poi_address": "6837 S Memorial Dr SUITE D, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed food truck and restaurant serving traditional Hawaiian comfort foods such as Spam musubi.",
      "poi_long_description": "People say this Hawaiian restaurant serves delicious spam musubi, loco moco, and macaroni salad. They highlight the generous portions and reasonable prices. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-ca29-7570-9800-afcfe249cdee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ca29-7570-9800-afcfe249cdee",
        "storage_key": "property/6767906449165586/019d7911-ca29-7570-9800-afcfe249cdee.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://fs-hawaiian-food.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17769431344943442333&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "f-s-hawaiian-food",
      "poi_latitude": "36.0648876",
      "poi_longitude": "-95.8846485",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-900-1973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw1RXNkuNtocRnakLaKmzmfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_7c969480-1b6d-4c85-aa0d-d3421da1fb7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Blue Coast Juicy Seafood",
      "poi_type": "Restaurants",
      "poi_address": "8215 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual venue serving fried baskets, boiled bags of seafood, and grilled fish such as shrimp and crab to eat in or take away, plus beer, wine, and hard liquor.",
      "poi_long_description": "People say this restaurant serves delicious seafood boils, especially the E Combo Special with lobster tail, shrimp, and snow crab. They also highlight the generous portions, flavorful seasoning, and reasonable prices for the boil combos.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-c890-739e-b031-d7a9592bf361.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c890-739e-b031-d7a9592bf361",
        "storage_key": "property/6767906449165586/019d7911-c890-739e-b031-d7a9592bf361.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://bluecoastjuicytulsa.com/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2767304385105026187&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blue-coast-juicy-seafood",
      "poi_latitude": "36.0613365",
      "poi_longitude": "-95.8850021",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-258-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5aprcuiNtocRi9yQK61wZyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d24d2abc-1a93-4ecb-b2fa-34cd72e60a84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Rocket Brothers",
      "poi_type": "Restaurants",
      "poi_address": "9705 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Drive-thru for coffee and related drinks, plus baked goods.",
      "poi_long_description": "People say this coffee shop offers delicious coffee drinks, including iced lattes and specialty options like pumpkin pie lattes. They highlight the convenient drive-thru service and the friendly, knowledgeable staff. They also like the quick and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-caad-7199-bdf2-2dbcb12c56f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-caad-7199-bdf2-2dbcb12c56f1",
        "storage_key": "property/6767906449165586/019d7911-caad-7199-bdf2-2dbcb12c56f1.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://rocketbrothers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10611677089520105962&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rocket-brothers",
      "poi_latitude": "36.0758059",
      "poi_longitude": "-95.8677196",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-355-3756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7912-1db7-70d6-874f-ff31a97d0256.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1db7-70d6-874f-ff31a97d0256",
        "storage_key": "property/6767906449165586/019d7912-1db7-70d6-874f-ff31a97d0256.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJpwlI8aeNtocR6jn__xZARJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_84f9ecb0-1976-49f7-b0de-25faf3439bb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7019 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious soups, salads, breadsticks, and entrees. They also highlight the generous portions, great prices, and friendly, efficient service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-cd02-7543-acca-0beb22e2f2bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cd02-7543-acca-0beb22e2f2bd",
        "storage_key": "property/6767906449165586/019d7911-cd02-7543-acca-0beb22e2f2bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/tulsa/tulsa-memorial/1054?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:tulsa-ok-1054_pl:locurl_rd:1028",
      "poi_directions_map_url": "https://maps.google.com/?cid=1956020961746126449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.062018",
      "poi_longitude": "-95.885692",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-254-0082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ar2VJCNtocRcYYYhrMuJRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_e2e08875-a2f4-4066-816b-4a44d742f4d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "4651 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "People say this seafood restaurant serves delicious Bang Bang shrimp, Imperial Cod, and Brussels sprouts. They highlight the excellent service, welcoming atmosphere, and tasty complimentary bread. They also like the attentive staff and the perfect music for the occasion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-d6ba-77cc-8c11-28fad4719000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d6ba-77cc-8c11-28fad4719000",
        "storage_key": "property/6767906449165586/019d7911-d6ba-77cc-8c11-28fad4719000.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/oklahoma/broken-arrow/4651-w.-kenosha-street?y_source=1_MTU1MDI2OTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058823268018440839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.059982",
      "poi_longitude": "-95.8478642",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-252-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wz1zUiMtocRh0oQjCvVeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_2f9cacd7-cebb-41f6-ba43-9204017922ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a great selection of products and easy returns. They also highlight the quick and efficient service provided by the SFS and drive-up crew, and the helpfulness of some employees.\n\nOther reviews mention the self-checkout can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-ddc5-7488-9f9d-69276e439dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ddc5-7488-9f9d-69276e439dcd",
        "storage_key": "property/6767906449165586/019d7911-ddc5-7488-9f9d-69276e439dcd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-se/1782",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072252321475274749&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0628683",
      "poi_longitude": "-95.8567584",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-307-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ67yjULONtocR_ScHtdKKqJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c62a1ebe-c5c6-44a4-a3c2-8652c2274092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, laptops, and appliances. They also highlight the knowledgeable and helpful staff, and the convenient online ordering and pick-up service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-ddd3-759f-bd8a-b9fd7a9665cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ddd3-759f-bd8a-b9fd7a9665cf",
        "storage_key": "property/6767906449165586/019d7911-ddd3-759f-bd8a-b9fd7a9665cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/tulsa/10303-e-71st-st-221.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2994601933184998961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.064164",
      "poi_longitude": "-95.86075",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-6819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5SOWULGNtocRMZ4wl5f2jik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_8e0355c9-a908-42cd-a62b-bf048ecd89db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-e29a-73ba-942d-fd39d06ad9af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e29a-73ba-942d-fd39d06ad9af",
        "storage_key": "property/6767906449165586/019d7911-e29a-73ba-942d-fd39d06ad9af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_808f9e56-a63f-491f-b4fa-cb14be1f1c96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6625 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer stocking toys, clothing, electronics, home goods, furniture, groceries and more.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, clothing, and household items. They also highlight the convenient one-stop shopping experience and the affordable prices.\n\nOther reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-e6dd-733a-88a4-b6ab498f128c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e6dd-733a-88a4-b6ab498f128c",
        "storage_key": "property/6767906449165586/019d7911-e6dd-733a-88a4-b6ab498f128c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/894-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18164824787754373520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0674096",
      "poi_longitude": "-95.8830124",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-294-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjfQHJZqNtocRkFFPMedrFvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_56567164-3a89-4aea-b1b0-338d9217071d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "10156 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a huge selection of products at competitive prices, and they appreciate the helpful, knowledgeable staff. They also highlight the friendly and efficient customer service, making for a pleasant shopping experience.\n\nSome reviews mention the staff can be difficult to find.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-6a7e-770f-b8b6-971804475a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb39-6a7e-770f-b8b6-971804475a3a",
        "storage_key": "property/6767906449165586/019cfb39-6a7e-770f-b8b6-971804475a3a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Tulsa/0243?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-243-_-na-_-0-_-0&y_source=1_MTE4NDQwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6856323657873291907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "36.058601",
      "poi_longitude": "-95.862348",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-459-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ25byKLGNtocRg_qkXAqOJl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3f6eb46d-212a-4612-8328-fd7e89fe1038",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Mathis Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "6611 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain selling furniture for every room in the home at budget-friendly prices.",
      "poi_long_description": "People say this furniture store offers a wide selection of mattresses, recliners, and other home furnishings. They highlight the helpful, knowledgeable, and professional staff, and the free delivery service. They also like the friendly and not pushy sales approach.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-f204-7245-afbd-ee93254ac277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f204-7245-afbd-ee93254ac277",
        "storage_key": "property/6767906449165586/019d7911-f204-7245-afbd-ee93254ac277.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.mathishome.com/stores/tulsa-52.html?utm_source=google&utm_medium=gbp&utm_campaign=website-button&utm_term=mbf-52&utm_content=website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=18144859354603892312&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mathis-home",
      "poi_latitude": "36.0677034",
      "poi_longitude": "-95.861197",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-461-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTURj6q2NtocRWK6WinJ9z_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_a953b48c-b78e-4651-8a5e-246180d2c1d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "7120 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Shoppers say this clothing store offers great deals on jeans, leggings, and other items. They also highlight the good prices.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-f2f3-7088-b512-ab58b401aeb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f2f3-7088-b512-ab58b401aeb7",
        "storage_key": "property/6767906449165586/019d7911-f2f3-7088-b512-ab58b401aeb7.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10105879525443396665&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "36.0603421",
      "poi_longitude": "-95.8890098",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-252-0680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP68_C46NtocROWTymOJLP4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_654e0f4a-e857-4ce7-87f3-a0a8ecc6b4f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "JCPenney",
      "poi_type": "Shopping & Retail",
      "poi_address": "6931 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, jewelry, and accessories, and often has good deals.\n\nOther reviews mention the customer service can be unhelpful and the store can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-f58f-732d-b857-8d6dd25a6924.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f58f-732d-b857-8d6dd25a6924",
        "storage_key": "property/6767906449165586/019d7911-f58f-732d-b857-8d6dd25a6924.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jcpenney.com/locations/ok/tulsa/clothing-stores-tulsa-ok-2237.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12114644083065215896&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jcpenney",
      "poi_latitude": "36.062596",
      "poi_longitude": "-95.881505",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-252-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiUoEPZeNtocRmNtjf5vcH6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_998634ad-2683-44ee-81fd-17121aafd59e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "SEPHORA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr STE 215, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_long_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-f3d2-710f-82b9-7052da25a419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f3d2-710f-82b9-7052da25a419",
        "storage_key": "property/6767906449165586/019d7911-f3d2-710f-82b9-7052da25a419.webp",
        "width": 500,
        "height": 277
      },
      "poi_business_url": "https://www.sephora.com/happening/stores/tulsa-woodland-hills?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14577707517912436268&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sephora",
      "poi_latitude": "36.063001",
      "poi_longitude": "-95.881663",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-307-8434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRLE62ZMBrTso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_f9371696-cf0a-421a-a9c7-7cf268b52d55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "HobbyTown",
      "poi_type": "Shopping & Retail",
      "poi_address": "6808 S Memorial Dr #116, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain with hobby-related merchandise, including model airplanes, remote-controlled cars & games.",
      "poi_long_description": "People say this hobby store offers a wide variety of hobby supplies, including model kits, remote control kits, and Gunpla. They also highlight the knowledgeable and helpful staff, and the great selection of RC cars, trucks, boats, and planes.\n\nOther reviews mention the prices can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7912-0ea4-74a2-95f2-333188d5cd8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0ea4-74a2-95f2-333188d5cd8b",
        "storage_key": "property/6767906449165586/019d7912-0ea4-74a2-95f2-333188d5cd8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbytown.com/tulsa-ok/l74",
      "poi_directions_map_url": "https://maps.google.com/?cid=17085460771021240656&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobbytown",
      "poi_latitude": "36.0670706",
      "poi_longitude": "-95.8891744",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-307-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8278-70ca-960f-d8b3b0f7f36c",
        "storage_key": "property/6767906449165586/019cfb39-8278-70ca-960f-d8b3b0f7f36c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkQRPJ5KNtocRULmXcAzAG-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_d8ffa14b-5872-4148-864d-6e72764471a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Cinergy's Extreme Escape Room - Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6808 S Memorial Dr Suite #300, Tulsa, OK 74133, USA",
      "poi_short_description": "Escape room center with ax throwing, bowling, and a bar, plus a movie theater.",
      "poi_long_description": "People say this escape room center offers a variety of escape rooms and an arcade. They also highlight the fun atmosphere and the opportunity to win prizes.\n\nSome reviews mention the escape rooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7911-fce9-72bf-9d96-0dfb50d08aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fce9-72bf-9d96-0dfb50d08aee",
        "storage_key": "property/6767906449165586/019d7911-fce9-72bf-9d96-0dfb50d08aee.webp",
        "width": 1200,
        "height": 786
      },
      "poi_business_url": "https://www.cinergy.com/escape-room/tulsa?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-escape",
      "poi_directions_map_url": "https://maps.google.com/?cid=5180287137507824221&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinergy-s-extreme-escape-room-tulsa",
      "poi_latitude": "36.0640143",
      "poi_longitude": "-95.8890616",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-894-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYRH29AyNtocRXdKtibQT5Ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_0f4a1225-f452-4dd0-8f95-66af68fd0d61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Dave & Buster's Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6812 S 105th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant and entertainment venue offers delicious food, tasty drinks, and a wide variety of arcade games. They also highlight the friendly and helpful staff, and the fun and exciting atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7912-021d-732b-b509-57863bd6a1de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-021d-732b-b509-57863bd6a1de",
        "storage_key": "property/6767906449165586/019d7912-021d-732b-b509-57863bd6a1de.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357992769235283287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave-buster-s-tulsa",
      "poi_latitude": "36.0651384",
      "poi_longitude": "-95.8605908",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-449-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-8271-72be-900e-3d1b9985a7df",
        "storage_key": "property/6767906449165586/019cfb39-8271-72be-900e-3d1b9985a7df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_GbT6yNtocRV20du_JogKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5cace4d7-7add-4ae3-92c2-c696c80d5e8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019d7912-0894-744f-9aee-4a71cf568556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0894-744f-9aee-4a71cf568556",
        "storage_key": "property/6767906449165586/019d7912-0894-744f-9aee-4a71cf568556.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-82af-7692-bd2d-6eac6b4a94c2",
        "storage_key": "property/6767906449165586/019cfb39-82af-7692-bd2d-6eac6b4a94c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_29ec228e-8650-44d2-96b2-01e050e47e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_82897f7e-3355-458e-bb0e-b53e236eeac7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Regent Preparatory School (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-school-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_524e4bf5-2697-43a6-8686-7dd475e84397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "All Star Sports Complex",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "all-star-sports-complex",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e3ef8d36-4dd7-4cae-be66-2c026b37cf06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "poi_name": "Cinemark Movie Theater",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "cinemark-movie-theater",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_458bf452e63a7acccafa8e98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a087340e4fa928a4842084a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6edf9410812497b79b730aa2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_27b2adea70b849c856591b00",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cabce11e8beebccf48b5bea3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7df83011a4862bb92394f32b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_67321e9a4f2fe023f4db701b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_debe9fd1-f03d-4f36-b6e1-e9eecdfe6a6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "rating": "5.0",
      "name": "Janice Silverman",
      "text": "Our maintenance men are efficiently handling our work orders. My last work order, I was concerned about the electrical outlet behind my stove. The maintenance man arrived immediately to be sure it was safe. Thank you for being so efficient and helping the residents feel safe at the Barrington Apartments.",
      "date": "2025-09-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ca00c834-c3d5-4249-8971-c867f50d448c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb3a-0f60-77be-9a0c-f1b338eaff40.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of the swimming pool area with lounge chairs and tables",
        "public_id": "019cfb3a-0f60-77be-9a0c-f1b338eaff40",
        "storage_key": "property/6767906449165586/019cfb3a-0f60-77be-9a0c-f1b338eaff40.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Barrington Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304be7e3bd8dd2e49eb9810"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-ba74-70e9-9951-af8eb0c2fc55",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "barrington-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586"
    },
    {
      "lead_collector_id": "019cf79e-1847-723f-b228-47581cd95592",
      "lead_source": "LANDING_PAGE",
      "name": "barrington-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-south-tulsa",
      "search_query": "apartments with in-unit laundry South Tulsa",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in South Tulsa",
      "h2_subtitle": "Discover South Tulsa living with in-unit laundry. Barrington Apartments offers comfort and convenience with spacious layouts and modern amenities.",
      "page_copy": "Experience the ultimate comfort at Barrington Apartments, located in the heart of South Tulsa. Our apartments with in-unit laundry provide the perfect blend of convenience and style, making daily chores effortless. Choose from our selection of one, two, or three-bedroom layouts, each designed with your lifestyle in mind. \n\nAt Barrington Apartments, we're dedicated to enhancing your living experience. Beyond in-unit laundry, enjoy a range of modern amenities including a refreshing pool, a state-of-the-art fitness center, and serene picnic areas. Embrace a smoke-free environment and benefit from dependable maintenance on site. Elevate your living experience today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments South Tulsa",
      "seo_description": "Discover in-unit laundry apartments in South Tulsa at Barrington. Enjoy modern amenities and spacious living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "barrington-apartments-pool-tulsa-ok",
      "search_query": "Barrington Apartments pool Tulsa OK",
      "category": "Amenity",
      "h1_title": "Barrington Apartments Pool in Tulsa, OK",
      "h2_subtitle": "Enjoy a refreshing dip at our Tulsa pool. Barrington Apartments offers a sparkling pool and more in South Tulsa's vibrant community.",
      "page_copy": "Escape the Oklahoma heat at Barrington Apartments with our sparkling pool in Tulsa, OK. Our resort-style pool offers the perfect spot to relax, unwind, and soak up the sun right in the heart of South Tulsa. Whether you're planning a revitalizing swim or a laid-back afternoon by the water, Barrington Apartments provides an unmatched living experience.\n\nAlongside our luxurious pool, Barrington Apartments features spacious one, two, and three-bedroom homes, each with modern conveniences like in-unit laundry. Enjoy our top-tier amenities, including a state-of-the-art fitness center, picnic areas, and vibrant playgrounds. Come experience the joy of living in a community designed for your comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Barrington Apartments Pool in Tulsa, OK",
      "seo_description": "Discover the sparkling pool at Barrington Apartments in Tulsa, OK. Enjoy comfort and style in South Tulsa's prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-south-tulsa",
      "search_query": "fitness center apartments South Tulsa",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in South Tulsa",
      "h2_subtitle": "Stay fit right at home in South Tulsa. Barrington Apartments offers a modern fitness center and a host of other amenities.",
      "page_copy": "Enhance your lifestyle at Barrington Apartments, where our fitness center apartments in South Tulsa provide the perfect setting for a healthy living routine. Our state-of-the-art fitness center is equipped with everything you need to maintain your active lifestyle without leaving the comfort of home. Whether you're a morning jogger or an evening weightlifter, our gym is ready for you.\n\nBeyond fitness, relish in spacious one, two, or three-bedroom layouts that cater to all your needs. Unwind by our pool, enjoy a picnic at one of our serene areas, or let the kids explore our vibrant playgrounds. Located in the vibrant South Tulsa community, Barrington Apartments offers a seamless blend of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in South Tulsa",
      "seo_description": "Enjoy a premier fitness center at Barrington Apartments in South Tulsa. Experience a blend of modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-tulsa-74133",
      "search_query": "apartments with dishwasher Tulsa 74133",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Tulsa 74133",
      "h2_subtitle": "Discover convenience in Tulsa 74133. Barrington Apartments offers units with dishwashers, enhancing your living experience in South Tulsa.",
      "page_copy": "Welcome to Barrington Apartments, where modern living meets convenience in Tulsa 74133. Our apartments, equipped with dishwashers, make daily chores a breeze, allowing you more time to enjoy the vibrant lifestyle South Tulsa offers. Choose from various spacious one, two, or three-bedroom layouts, all designed with comfort in mind.\n\nIn addition to having a dishwasher, residents can indulge in a range of amenities like a sparkling pool, modern fitness center, and family-friendly playgrounds. Nestled in the heart of Tulsa, Barrington Apartments provides easy access to local dining, shopping, and entertainment, creating a seamless living experience for all.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Tulsa 74133",
      "seo_description": "Find stylish apartments with dishwashers in Tulsa 74133. Experience comfort and convenience at Barrington Apartments in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "kid-friendly-apartments-with-playground-tulsa",
      "search_query": "kid-friendly apartments with playground Tulsa",
      "category": "Amenity",
      "h1_title": "Kid-Friendly Apartments with Playground in Tulsa",
      "h2_subtitle": "Explore family living in Tulsa at Barrington Apartments. Our kid-friendly community features vibrant playgrounds and engaging amenities.",
      "page_copy": "At Barrington Apartments, we provide the perfect setting for families seeking kid-friendly apartments with playgrounds in Tulsa. Our vibrant playgrounds are designed for endless fun, ensuring your children have a safe and joyful environment to play and make new friends. Located in the lively South Tulsa area, our community offers a harmonious blend of family-friendly amenities and modern conveniences.\n\nChoose from spacious one, two, or three-bedroom floor plans that cater to family needs. Beyond playful adventures, enjoy a sparkling pool, a well-equipped fitness center, and tranquil picnic areas. Barrington Apartments is committed to delivering a warm, welcoming atmosphere where families can thrive and enjoy the best of Tulsa living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kid-Friendly Apartments with Playground in Tulsa",
      "seo_description": "Discover kid-friendly apartments with playgrounds in Tulsa. Experience family living at Barrington Apartments in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-tulsa",
      "search_query": "one bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover cozy one-bedroom apartments in South Tulsa. Barrington Apartments offers ideal layouts in a vibrant community.",
      "page_copy": "Experience the charm and convenience of our one-bedroom apartments in South Tulsa at Barrington Apartments. Each unit is thoughtfully designed to provide a cozy yet spacious living environment, perfect for individuals seeking comfort and style. Located in vibrant South Tulsa, our community combines the benefits of urban living with the tranquility of a suburban setting.\n\nBeyond the stylish interiors, enjoy our array of amenities, including a sparkling pool, a modern fitness center, and peaceful picnic areas, all designed to enhance your lifestyle. At Barrington Apartments, we offer more than just a place to live; we offer a community you can call home, right in the heart of South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Tulsa",
      "seo_description": "Find charming one-bedroom apartments in South Tulsa. Experience comfort and convenience at Barrington Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-ok",
      "search_query": "two bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Explore spacious two-bedroom apartments in Tulsa, OK. Barrington Apartments offers modern layouts in a welcoming community.",
      "page_copy": "Discover the perfect blend of style and functionality with our two-bedroom apartments in Tulsa, OK, at Barrington Apartments. Our well-designed layouts provide ample space, making them ideal for couples, roommates, or small families. Nestled in the heart of Tulsa, our community ensures easy access to local amenities while providing a peaceful retreat.\n\nBeyond the comfortable living spaces, residents can enjoy a range of amenities such as a refreshing swimming pool, a state-of-the-art fitness center, and serene picnic areas. At Barrington Apartments, you can experience the perfect balance of convenience and comfort every day, making it the ideal place to call home in Tulsa, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Tulsa, OK",
      "seo_description": "Explore spacious two-bedroom apartments in Tulsa, OK at Barrington Apartments. Comfort and convenience await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-74133",
      "search_query": "three bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 74133",
      "h2_subtitle": "Find ideal three-bedroom apartments near the 74133 area. Discover Barrington Apartments' spacious options designed for comfort.",
      "page_copy": "If you're looking for spacious three-bedroom apartments near the 74133 area, Barrington Apartments is the perfect choice. Our generously-sized units offer ample room for families or anyone needing extra space, all within a vibrant community in Tulsa. Conveniently located near the 74133 zip code, our apartments provide easy access to the best local attractions and amenities.\n\nEnjoy the wide array of community features, including a sparkling pool, a modern fitness center, and family-friendly playgrounds. Barrington Apartments combines elegant living spaces with essential amenities, making it an ideal location for those seeking a comfortable and convenient lifestyle in Tulsa's thriving neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 74133",
      "seo_description": "Discover spacious three-bedroom apartments near 74133. Enjoy comfortable living at Barrington Apartments in Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "apartments-near-oral-roberts-university-tulsa",
      "search_query": "apartments near oral roberts university tulsa",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University",
      "h2_subtitle": "Explore comfortable apartments near Oral Roberts University in Tulsa. Barrington Apartments offers convenience and style just minutes away.",
      "page_copy": "Located just a short drive from Oral Roberts University, Barrington Apartments offers ideal living options for students and faculty seeking nearby accommodations in Tulsa. Our community features a selection of one, two, and three-bedroom apartments designed with comfort and accessibility in mind, providing a perfect balance between academia and leisure.\n\nResidents at Barrington Apartments enjoy a host of amenities, including a refreshing pool, a fully-equipped fitness center, and serene picnic areas. With the convenience of being close to Oral Roberts University and the vibrant atmosphere of South Tulsa, our community is the ideal place to call home. Discover the ease of living near campus while enjoying modern comforts and community amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oral Roberts University",
      "seo_description": "Find apartments near Oral Roberts University at Barrington Apartments. Enjoy proximity and comfort in Tulsa, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "barrington-apartments-near-tcc-southeast",
      "search_query": "barrington apartments close to tulsa community college southeast campus",
      "category": "School",
      "h1_title": "Barrington Apartments Near TCC Southeast",
      "h2_subtitle": "Discover Barrington Apartments, conveniently close to Tulsa Community College Southeast Campus. Experience easy access and comfortable living.",
      "page_copy": "Barrington Apartments offers a perfect living solution for those attending or working at Tulsa Community College's Southeast Campus. Located just a short commute away, our community provides easy access to the campus while ensuring a comfortable and vibrant living environment. Choose from our variety of floor plans, including spacious one, two, and three-bedroom layouts designed to suit any lifestyle.\n\nEnjoy the array of amenities available at Barrington Apartments, such as a refreshing swimming pool, a modern fitness center, and peaceful picnic areas. With its proximity to Tulsa Community College Southeast Campus and the welcoming environment, Barrington Apartments is the ideal choice for students and professionals seeking convenience and comfort in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Barrington Apartments Near TCC Southeast",
      "seo_description": "Live close to TCC Southeast at Barrington Apartments. Find comfort and convenience near Tulsa Community College in Tulsa, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "south-tulsa-apartments-near-ou-tulsa",
      "search_query": "south tulsa apartments by ou-tulsa",
      "category": "School",
      "h1_title": "South Tulsa Apartments By OU-Tulsa",
      "h2_subtitle": "Explore South Tulsa apartments near OU-Tulsa. Barrington Apartments offers proximity and style for students and staff.",
      "page_copy": "Located in the vibrant neighborhood of South Tulsa, Barrington Apartments provides an ideal living option for those connected to OU-Tulsa. Our community is just a convenient commute away from the university, offering students, faculty, and staff a perfect blend of accessibility and comfort. Choose from thoughtfully designed one, two, or three-bedroom units that cater to diverse needs.\n\nBarrington Apartments is more than just a place to live; it's a community with premium amenities like a glistening pool, a state-of-the-art fitness center, and scenic picnic areas. Experience living in South Tulsa where the conveniences of city life meet a serene residential atmosphere, all while being close to OU-Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apartments Near OU-Tulsa",
      "seo_description": "Find South Tulsa apartments by OU-Tulsa at Barrington Apartments. Enjoy convenience and comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa",
      "search_query": "apartments near saint francis hospital tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital Tulsa",
      "h2_subtitle": "Discover apartments near Saint Francis Hospital Tulsa. Barrington Apartments offers comfort and proximity for professionals and families.",
      "page_copy": "Barrington Apartments is ideally located near Saint Francis Hospital in Tulsa, providing a convenient living option for healthcare professionals and families seeking proximity to medical services. Our selection of one, two, and three-bedroom apartments is crafted to deliver both comfort and style, making it easy to relax and unwind after a long day.\n\nResidents enjoy the inviting amenities of Barrington Apartments, such as a sparkling pool, a well-equipped fitness center, and charming picnic areas. Our community is smoke-free and offers on-site maintenance, ensuring peace of mind. Experience stress-free living with easy access to Saint Francis Hospital, all within the welcoming environment of South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital Tulsa",
      "seo_description": "Find convenient apartments near Saint Francis Hospital Tulsa at Barrington Apartments. Experience comfort and proximity in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "south-tulsa-apartments-near-hillcrest-south",
      "search_query": "south tulsa apartments close to hillcrest south hospital",
      "category": "Hospital",
      "h1_title": "South Tulsa Apartments Near Hillcrest South",
      "h2_subtitle": "Discover South Tulsa apartments close to Hillcrest South Hospital. Experience convenience and comfort with Barrington Apartments.",
      "page_copy": "Located in the bustling area of South Tulsa, Barrington Apartments is an excellent choice for those seeking proximity to Hillcrest South Hospital. Our community is perfectly positioned to offer quick access to healthcare professionals and hospital staff needing a place that balances professional demands with personal comfort. With spacious one, two, and three-bedroom layouts, Barrington Apartments caters to a range of lifestyles.\n\nOur residents enjoy a variety of amenities, including a pristine swimming pool, a modern fitness center, and inviting picnic areas for outdoor relaxation. The smoke-free community combined with on-site maintenance ensures a hassle-free living experience. Choose Barrington Apartments for convenient living near Hillcrest South Hospital, and enjoy the best of South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apartments Near Hillcrest South",
      "seo_description": "Live near Hillcrest South Hospital at Barrington. Enjoy convenience and comfort in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-tulsa",
      "search_query": "apartments near rhema park tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park Tulsa",
      "h2_subtitle": "Explore apartments near Rhema Park Tulsa. Discover the ideal blend of nature and city life at Barrington Apartments.",
      "page_copy": "Find your perfect home at Barrington Apartments, situated conveniently near Rhema Park in Tulsa. Our community offers a prime location for those who enjoy being close to nature without sacrificing urban conveniences. Choose from our spacious one, two, and three-bedroom apartment designs that highlight both privacy and comfort for residents.\n\nRelish the resort-style amenities Barrington Apartments has to offer, such as a shimmering pool and a fully-equipped fitness center, all set in a smoke-free environment. Enjoy the beautiful surroundings and outdoor activities at Rhema Park just a short distance away. Experience a harmonious lifestyle at Barrington Apartments, close to the tranquility of Rhema Park and the conveniences of South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park Tulsa",
      "seo_description": "Discover Barrington Apartments near Rhema Park Tulsa. Enjoy city life and nature close by in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "barrington-apartments-near-lafortune-park",
      "search_query": "barrington apartments close to lafortune park",
      "category": "Park",
      "h1_title": "Barrington Apartments Near LaFortune Park",
      "h2_subtitle": "Discover Barrington Apartments close to LaFortune Park in Tulsa. Enjoy endless outdoor activities and comfortable living in our community.",
      "page_copy": "Barrington Apartments offers the perfect living experience close to LaFortune Park in Tulsa. Located conveniently in South Tulsa, our community is an excellent choice for those who love outdoor activities and require both comfort and accessibility. Choose from our range of spacious one, two, and three-bedroom apartment homes, perfect for all lifestyles.\n\nEnjoy the convenience of top-notch amenities at Barrington Apartments, including a refreshing pool, modern fitness center, and beautiful picnic areas. Our smoke-free environment and on-site maintenance ensure a hassle-free living experience. Embrace the abundant leisure options at LaFortune Park while living in the comfort of our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Barrington Apartments Near LaFortune Park",
      "seo_description": "Experience Barrington Apartments near LaFortune Park, offering comfort and proximity to outdoor activities in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "south-tulsa-apartments-near-elam-park",
      "search_query": "south tulsa apartments near elam park",
      "category": "Park",
      "h1_title": "South Tulsa Apartments Near Elam Park",
      "h2_subtitle": "Find South Tulsa apartments near Elam Park at Barrington. Enjoy urban living with a touch of nature in our inviting community.",
      "page_copy": "Discover the ideal blend of urban living and natural beauty at Barrington Apartments, located near Elam Park in South Tulsa. A perfect home for those who appreciate easy access to outdoor spaces, our community offers spacious one, two, and three-bedroom apartments, designed for comfort and style.\n\nResidents at Barrington Apartments enjoy a variety of amenities, including a sparkling pool, a state-of-the-art fitness center, and a serene picnic area. The smoke-free environment and on-site maintenance team enhance your living experience. Enjoy and explore the nearby Elam Park while benefiting from the convenience of life at Barrington Apartments, a true oasis in the heart of South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apartments Near Elam Park",
      "seo_description": "Live at Barrington Apartments, conveniently located near Elam Park in South Tulsa. Enjoy the perfect mix of comfort and outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "apartments-by-hunter-park-oklahoma",
      "search_query": "apartments by hunter park oklahoma",
      "category": "Park",
      "h1_title": "Apartments by Hunter Park Oklahoma",
      "h2_subtitle": "Explore Barrington Apartments near Hunter Park Oklahoma. Enjoy a vibrant community with top amenities and outdoor access.",
      "page_copy": "Nestled near Hunter Park in Oklahoma, Barrington Apartments offers a delightful living experience for those who cherish both convenience and the great outdoors. Our community provides carefully designed one, two, and three-bedroom options that cater to varied lifestyles, ensuring you're never far from comfort and style.\n\nEnjoy the impressive amenities at Barrington, such as a shimmering pool, a contemporary fitness center, and beautiful picnic areas. With a smoke-free environment and dedicated on-site maintenance, residents experience peace of mind and hassle-free living. Discover the joys of living by Hunter Park, with ample green spaces and recreational opportunities, all while luxuriating in the charming apartments at Barrington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Hunter Park Oklahoma",
      "seo_description": "Find your new home at Barrington Apartments, located near Hunter Park Oklahoma, offering comfort and outdoor enjoyment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165586",
      "source": "generator",
      "page_item_url": "barrington-apartments-near-haikey-creek-park",
      "search_query": "barrington apartments close to haikey creek park",
      "category": "Park",
      "h1_title": "Barrington Apartments Near Haikey Creek Park",
      "h2_subtitle": "Discover Barrington Apartments close to Haikey Creek Park. Enjoy serene living with both modern amenities and outdoor adventures nearby.",
      "page_copy": "Barrington Apartments, situated near Haikey Creek Park, offers the perfect setting for a serene lifestyle intertwined with nature. Nestled in South Tulsa, our community features spacious and stylish one, two, and three-bedroom homes designed to cater to your comfort and convenience.\n\nResidents enjoy a wealth of amenities including a sparkling pool, contemporary fitness center, and inviting picnic areas. Our smoke-free environment and responsive on-site maintenance ensure hassle-free living. Explore the natural beauty of Haikey Creek Park with its walking trails and recreational spaces, while enjoying the modern comforts Barrington Apartments provides. Experience a balanced lifestyle just minutes from outdoor adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, coffee table, and laundry area.",
        "public_id": "019cfb39-5afc-7459-b69a-0769dd25279f",
        "storage_key": "property/6767906449165586/019cfb39-5afc-7459-b69a-0769dd25279f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Barrington Apartments Near Haikey Creek Park",
      "seo_description": "Live at Barrington Apartments, conveniently close to Haikey Creek Park, offering comfort and a seamless blend of nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5147"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-S41F0DRG2G"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151426"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/barrington-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MZZ9QZBT"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165586/019d1bd6-e7ca-7512-9497-04e7b32bf24e.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8442922139"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-624-7043"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64418528c13f36b6699ca996"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IllqOUlJeTVROExoTnE3bVZxZ2FSRXc9PSIsInZhbHVlIjoidlNaVWNTWDk4M2hnRXhndklhSkp2QT09IiwibWFjIjoiMzM1YjcxYzc2ZDFmOWU5NDhhZmNmYzViNGZiMzgzNjdmNmE3ZjQ2YTFmNzU1NmRjY2ZhODllMzIwNTNiZjljNCJ9"
    }
  ],
  "custom_qb_id": "5147",
  "custom_ga4_id": "G-S41F0DRG2G",
  "custom_repli_id": "10041151426",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/barrington-apartments/register/",
  "custom_google_gtm_id": "GTM-MZZ9QZBT",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165586/019d1bd6-e7ca-7512-9497-04e7b32bf24e.pdf",
  "custom_hubspot_company_id": "8442922139",
  "custom_ppc_tracking_phone_number": "800-624-7043",
  "custom_residentboost_apartment_id": "64418528c13f36b6699ca996",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IllqOUlJeTVROExoTnE3bVZxZ2FSRXc9PSIsInZhbHVlIjoidlNaVWNTWDk4M2hnRXhndklhSkp2QT09IiwibWFjIjoiMzM1YjcxYzc2ZDFmOWU5NDhhZmNmYzViNGZiMzgzNjdmNmE3ZjQ2YTFmNzU1NmRjY2ZhODllMzIwNTNiZjljNCJ9"
};

export const generatedAt = '2026-08-27T21:39:43.497Z';
